"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));

var _urijs = _interopRequireDefault(require("urijs"));

var _AutocompleteBox = _interopRequireDefault(require("./AutocompleteBox.js"));

var _PropTypes = require("../PropTypes.js");

require("./tags.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var noTags = {
  allowedTags: [],
  allowedAttributes: []
};

var Main = function Main(_ref) {
  var geneQuery = _ref.geneQuery,
      onChangeGeneQuery = _ref.onChangeGeneQuery,
      geneSuggesterUri = _ref.geneSuggesterUri;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      overflowWrap: "break-word"
    }
  }, geneQuery.map(function (_ref2) {
    var value = _ref2.value,
        category = _ref2.category;
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: value + "" + category,
      className: "gxaTag"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      title: category ? "".concat(value, " (").concat(category, ")") : value
    }, value), /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        marginLeft: "0.2rem",
        position: "relative",
        cursor: "pointer"
      },
      "aria-hidden": "true",
      onClick: function onClick() {
        onChangeGeneQuery(geneQuery.filter(function (term) {
          return term.value !== value;
        }));
      }
    }, "\u2716"));
  }), /*#__PURE__*/_react["default"].createElement(_AutocompleteBox["default"], {
    geneSuggesterUri: geneSuggesterUri,
    valuesToSkipInSuggestions: geneQuery.map(function (_ref3) {
      var value = _ref3.value;
      return value;
    }),
    onGeneChosen: function onGeneChosen(newGeneSuggestionItem) {
      return onChangeGeneQuery([].concat(_toConsumableArray(geneQuery), [{
        value: (0, _sanitizeHtml["default"])(newGeneSuggestionItem.term, noTags),
        category: newGeneSuggestionItem.category
      }]));
    }
  }));
};

Main.propTypes = {
  geneQuery: _PropTypes.QueryObjectsPropTypes.geneQuery,
  onChangeGeneQuery: _propTypes["default"].func.isRequired,
  geneSuggesterUri: _propTypes["default"].instanceOf(_urijs["default"])
};
var _default = Main;
exports["default"] = _default;